export default __webpack_public_path__ + "static/media/transaction-icon.bea398ce.svg";